export default "__VITE_ASSET__4pLlNzP___"